

import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'
import VideoPlayer from 'vue-video-player'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'


import commonFun from '@/assets/utils/commonFun'
Vue.prototype.commonFun = commonFun;
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)

Vue.use(AjaxPlugin)
Vue.use(router)

Vue.use(VideoPlayer);
require('@/../static/css/myVideo.css');


/**
* 定义常量
*/

import global_ from '@/components/global.vue';

Vue.prototype.GLOBAL = global_
console.log(Vue.prototype.GLOBAL)

const loginTimeOutErrorCode = 'login_timeout_error'
if (global_.bIsDtDreamApp || global_.bIsAlipayMini) {
console.log('浙里办或者支付宝!!')
ZWJSBridge.onReady(() => {
console.log('ZWJSBridge_onReady!!')

ZWJSBridge.getUiStyle({})
.then((result) => {
switch (result.uiStyle) {
case 'normal':
sessionStorage.setItem('usertype', 'normal')
break;
case 'elder':


var HtmlContainer = window.document.querySelector('html')
HtmlContainer.setAttribute('style', 'font-size:70px !important')
sessionStorage.setItem('usertype', 'elder')
break;
default:
sessionStorage.setItem('usertype', 'normal')
}
console.log(result, '用户模式');
})

.catch((error) => {
sessionStorage.setItem('usertype', 'normal');
console.log(error);
});

})

}

var HtmlContainer = window.document.querySelector('html')
HtmlContainer.setAttribute('style', 'font-size:70px !important')


/**
* 定义全局公用常量
*/



/**
* 定义全局公用方法
*/
Vue.prototype.http = function (opts) {
let vue = this;
if (opts.isShowLoading) {
vue.$vux.loading.show({
text: '加载中...'
})
}


vue.$http({
method: opts.method,
url: opts.url,
headers: opts.headers || {},
params: opts.params || {},
data: opts.data || {}
}).then(function (response) {
vue.$vux.loading.hide()

opts.success(response)


}).catch(function (error) {
vue.$vux.loading.hide()
console.log(error)
if (!opts.error) {
console.log(!opts.error)
let response = error.response
let errorMessage = response.statusText
console.log(response)
console.log(errorMessage)















vue.$vux.alert.show({
title: '提示',
content: errorMessage

})
} else {
console.log(opts.error(error.response.data.data))
opts.error(error.response.data.data)
}
})
}

Vue.prototype.get = function (opts) {
opts.method = 'get'
this.http(opts)
}

Vue.prototype.post = function (opts) {
opts.method = 'post'
this.http(opts)
}

Vue.prototype.put = function (opts) {
opts.method = 'put'
this.http(opts)
}

Vue.prototype.delete = function (opts) {
opts.method = 'delete'
this.http(opts)
}

Vue.prototype.valid = function (opts) {
let vue = this
let valid = true

if (opts.ref && !opts.ref.valid) {
valid = false
}

if (opts.ignoreRefs) {
let newRefs = []
for (let i in opts.refs) {
let ref = opts.refs[i]
for (let j in opts.ignoreRefs) {
let ignoreRef = opts.ignoreRefs[j]
if (ref !== ignoreRef) {
newRefs.push(ref)
}
}
}
opts.refs = newRefs
}

for (let i in opts.refs) {
if (!opts.refs[i].valid) {
valid = false
break
}
}

if (valid) {
opts.success()
} else if (opts.error) {
opts.error()
} else {
vue.$vux.toast.show({
text: '请检查输入'
})
}
}



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js